module.exports = __webpack_public_path__ + "img/142.e21392de.jpg";